import { DescriptionItem, DescriptionList } from '@billda/design-system';
import type { LabourItemGroupDetails } from '../../../api/labourItemGroupsApi';

interface GroupOverviewCardProps {
  group: LabourItemGroupDetails;
}

export function GroupOverviewCard({ group }: GroupOverviewCardProps) {
  return (
    <DescriptionList data-testid="group-overview-card">
      <DescriptionItem label="Name" value={group.name} />
      <DescriptionItem
        label="Labour items"
        value={group.labourItems?.length || 0}
      />
    </DescriptionList>
  );
}
